import axios from 'axios';
import { urlAgencies } from '../utils';

export const apiAgency = axios.create({
    baseURL: `${urlAgencies}`
});